module.exports = __webpack_public_path__ + "static/media/notfound.f978af75.png";